import { Button, Dialog, Group } from '@economic/taco';
import { Trans } from '@lingui/macro';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
    redirectOnClose?: string;
}

export function SubscriptionChangeSuccessFooter({ redirectOnClose }: Props) {
    const navigate = useNavigate();

    return (
        <Dialog.Footer>
            <Group>
                <Button
                    onClick={() => {
                        if (redirectOnClose) {
                            navigate(redirectOnClose);
                        } else {
                            navigate(0);
                        }
                    }}>
                    <Trans>Close</Trans>
                </Button>
            </Group>
        </Dialog.Footer>
    );
}
